export const metatagilistahoteli = {
  Page: {
    "meta-tagi": {
      Title: "SkiOne.pl - lista hoteli",
      Description:
        "Wszystkie hotele ze SkiOne.pl dostępne do rezerwacji. Sprawdź listę wszystkich hoteli. Lista Hoteli ze SkiOne.pl – sprawdź gdzie i kiedy jechać! ::: Zaplanuj idealne wakacje z Grupą Portali TravelOne.pl!",
      Keywords: []
    }
  }
};
